const RESET_PASSWORD_FORM = {
    title: {
        text: 'reset_password.title'
    },
    submit: {
        label: 'reset_password.submit_btn'
    },
    fields: [
        {
            name: 'password',
            label: 'reset_password.password_field',
            type: 'password',
            validators: [
                'required',
                'minStringLength:8',
                'maxStringLength:32',
                'strongPassword'
            ],
            errors: [
                'errors.required_password',
                'errors.min_length_password',
                'errors.max_length_password',
                'errors.invalid_password_format'
            ],
            defaultValue: ''
        },
        {
            name: 'repeatPassword',
            label: 'reset_password.repeat_password_field',
            type: 'password',
            validators: ['required', 'isPasswordMatch'],
            errors: [
                'errors.required_repeat_password',
                'errors.password_mismatch'
            ],
            defaultValue: ''
        }
    ]
}

export default RESET_PASSWORD_FORM;
